import React, { useState } from 'react'
import Input from '../ui/forms/Input'
import Button from '../ui/comp/Button'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useParams } from 'react-router-dom'
import { Axios } from '../utils/Axios'
import toast from 'react-hot-toast'
import SubCategories from '../components/Subcategory/SubCategories'

function SubCategory() {

    const { id } = useParams()
    const queryClient = useQueryClient()

    const [formData, setFormData] = useState({ name: "", categoryId: id })

    // Adding Category
    const { mutate, isPending } = useMutation({
        mutationFn: () => {
            return Axios.post('/category/subcategory', formData)
        },
        onSuccess: () => {
            toast.dismiss()
            toast.success('Subcategory added')
            queryClient.invalidateQueries([id])
            setFormData({ ...formData, name: '' })
        },
        onError: (err) => {
            toast.dismiss()
            toast.error(err?.response?.data || err?.message)
        }
    })

    const addSubcategory = () => {
        mutate()
    }


    return (
        <div className='w-full relative'>
            {/* Add SubCategory */}
            <div className="w-full">
                <div className='flex items-center gap-3'>
                    <Input
                        placeholder='Subcategory Name...'
                        value={formData?.name}
                        onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                    />
                    <Button loading={isPending} onClick={addSubcategory} >Add</Button>
                </div>
            </div>


            <div className="mt-10">
                <SubCategories />
            </div>
        </div>
    )
}

export default SubCategory